import { ADDON_PRODUCT_RECEIVE, ADDON_SELECTION_SET } from '../Actions/AddonProduct.action';

export const addons = (state = { addons: [], mainArticleNumber: null, selection: [] }, action) => {
    switch (action.type) {
        case ADDON_PRODUCT_RECEIVE:
        case ADDON_SELECTION_SET:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}
